import {
  CERTIFICADO_SUCCESS,
  CERTIFICADO_LOADING,
  CERTIFICADO_ERROR,
  CERTIFICADO_RESET,
} from "../../ActionTypes";

import axiosLogin from "../../../../global/helpers/axiosLogin";

export const wsGetMisCertificados = (nextStep) => (dispatch) => {
  dispatch({ type: CERTIFICADO_LOADING });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`his/certificados`)
      .then((resp) => {
        dispatch({ type: CERTIFICADO_SUCCESS, payload: resp.data });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: CERTIFICADO_ERROR, payload: err.response?.data });
        if (nextStep) nextStep(false, err.response?.data);
      });
  });
};

export const wsGetCertificadoPdf = (idCertificado, nextStep) => (dispatch) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`his/certificados/pdf/${idCertificado}`)
      .then((resp) => {
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err.response?.data);
      });
  });
};

export const certificadosReset = () => (dispatch) => {
  dispatch({ type: CERTIFICADO_RESET });
};
